/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whose permissions the grant exceeds; absent when allowed.
 */
export const LimitedBy = {
  Caller: "caller",
  Owner: "owner",
} as const;
/**
 * Whose permissions the grant exceeds; absent when allowed.
 */
export type LimitedBy = OpenEnum<typeof LimitedBy>;

/**
 * Whether one policy grant could be written, by the same rule agents.create and agents.createPolicyGrant enforce.
 */
export type AgentPolicyGrantCheck = {
  /**
   * Whether the grant fits within the caller's and the owner's permissions.
   */
  allowed: boolean;
  /**
   * Whose permissions the grant exceeds; absent when allowed.
   */
  limitedBy?: LimitedBy | undefined;
};

/** @internal */
export const LimitedBy$inboundSchema: z.ZodMiniType<LimitedBy, unknown> =
  openEnums.inboundSchema(LimitedBy);

/** @internal */
export const AgentPolicyGrantCheck$inboundSchema: z.ZodMiniType<
  AgentPolicyGrantCheck,
  unknown
> = z.pipe(
  z.object({
    allowed: z.boolean(),
    limited_by: z.optional(LimitedBy$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "limited_by": "limitedBy",
    });
  }),
);

export function agentPolicyGrantCheckFromJSON(
  jsonString: string,
): SafeParseResult<AgentPolicyGrantCheck, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPolicyGrantCheck$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPolicyGrantCheck' from JSON`,
  );
}
